<template>
<div>
  <vb-form-row item-name="法人名/団体名" :required="false">
    <template #input>
      <v-sheet class="col-12 pa-0" :max-width="null">
        <validation-provider v-slot="{ errors }" name="法人名" rules="max:100|jis_level2_char"
                             mode="passive" ref="companyName">
          <v-text-field
            v-model="currentCompanyName"
            name="companyName"
            @blur="$refs.companyName.validate()"
            :error-messages="errors"
            outlined
            required
            dense
            :background-color="errors[0] ? 'red lighten-5' : 'accent2'"
            height="44px"
            hide-details="auto"
            solo
            flat
            maxlength="100"
          >
            <template #label><span class="text-body-2">法人または団体名義でのお申込みの場合、ご入力ください</span></template>
          </v-text-field>
        </validation-provider>
      </v-sheet>
    </template>
  </vb-form-row>
</div>
</template>

<script>
import VbFormRow from "../buy/vb-form-row.vue";

export default {
  name: "vb-company-name",
  components: {
    VbFormRow
  },
  props: {
    formItemsSetter: {
      type: Function,
      required: true
    },
    formItemsGetter: {
      type: Object,
      required: true,
      default: {}
    },
  },
  data() {
    return {
    }
  },
  methods: {
  },
  computed: {
    currentCompanyName: {
      get(){
        return this.formItemsGetter.companyName;
      },
      set(value) {
        this.formItemsSetter({name:'companyName', value: value});
      }
    }
  }
}
</script>

<style scoped>

</style>